import {
  toSignalLocationOption,
  useIntersectionsLocationTreeDataSource,
} from './useIntersectionsLocationTreeDataSource';

export const useDetectorGroupLocationTreeDataSource = () => {
  return useIntersectionsLocationTreeDataSource({
    centerIds: 'none',
    toLocationOption: toSignalLocationOption,
    groupsDisabled: true,
  });
};
